import { render, staticRenderFns } from "./FAQMan.vue?vue&type=template&id=805e1f38&scoped=true"
var script = {}
import style0 from "./FAQMan.vue?vue&type=style&index=0&id=805e1f38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "805e1f38",
  null
  
)

export default component.exports